export default __webpack_public_path__ + "static/media/people.efb689b5.svg";